import format from "date-fns/format";
import ptBR from "date-fns/locale/pt-BR";
import Head from "next/head";
import Link from "next/link";
import type { ReactElement } from "react";
import FundamenteiWithTextLayout from "../layouts/FundamenteiWithTextLayout";

interface IPolicyPageProps {
  title: string;
  lastUpdatedAt: Date;
  children: ReactElement;
}

export default function PolicyPage({ title, lastUpdatedAt, children }: IPolicyPageProps) {
  return (
    <FundamenteiWithTextLayout>
      <Head>
        <title>{title}</title>
      </Head>

      <main className="mx-auto mb-16 mt-8 max-w-7xl font-aeonik font-normal md:mb-12">
        <div>
          <div className="px-4">
            <h1 className="text-center text-3xl font-medium tracking-wide text-gray-800 md:text-left">{title}</h1>
          </div>

          {children}

          <div className="mt-7 flex flex-col items-center justify-between space-y-8 px-4 md:flex-row md:space-y-0">
            <Link href="/" className="text-md font-medium tracking-wide text-blue-600 hover:underline md:text-lg">
              ← Voltar para a página inicial
            </Link>

            <div className="flex flex-col space-y-2 text-center md:flex-row md:items-center md:space-x-2 md:space-y-0">
              <span className="text-base font-medium tracking-wide text-gray-600">Última atualização</span>

              <time
                dateTime="2019-09-08"
                className="rounded-full border border-violet-300 bg-violet-50 px-2 py-1 text-sm font-medium text-violet-600"
              >
                {format(lastUpdatedAt, `dd 'de' MMMM, yyyy`, {
                  locale: ptBR,
                })}
              </time>
            </div>
          </div>
        </div>
      </main>
    </FundamenteiWithTextLayout>
  );
}
